class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {

        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        if (typeof yotpoWidgetsContainer !== 'undefined' &&
            typeof yotpoWidgetsContainer.initWidgets === 'function') {
          yotpoWidgetsContainer.initWidgets(false);
        }
        this.getDeliveryDate(); // Appeler après avoir mis à jour le DOM
      })
      .catch(e => {
        console.error(e);
      });
  }
  getDeliveryDate() {
    if (typeof theme !== 'undefined' && typeof theme.getDeliveryDate === 'function') {
      const fromDate = theme.getDeliveryDate();
      let options = { weekday: 'long', month: 'long', day: 'numeric' };
      const text = document.getElementById("fromDate");
      if (text) {
        text.innerHTML = fromDate.toLocaleDateString('fr-FR', options);
      } else {
        console.error('Element with id "fromDate" not found inside mini-cart.');
      }
    }
  }
}
customElements.define('cart-recommendations', CartRecommendations);
